import React from 'react';
import {
    Modal,
    Input,
    Form,
    Button,
    Tooltip,
    Progress
} from 'antd';
const InputGroup = Input.Group;

class ContraseniaModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err){
                const form = {
                    id: values.id,
                    password: values.password
                }
                this.props.onSaveContrasenia(form, this.props.form);
            }
        });
    }

    generatePassword = (length) => {
        
        var result           = '';
        var characters       = '!#$$%&=?¡0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ!#$$%&=?¡0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
           result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        return (
            <Modal
                title="Restablecer Contraseña"
                visible={this.props.visibleContrasenia}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Nueva Contraseña">
                            <InputGroup compact>
                            {getFieldDecorator('password', {
                                    initialValue: this.props.formValues.password,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input   
                                        style={{ width: `calc(100% - 40px)` }}
                                        placeholder="Ingresar contraseña"
                                        autoComplete="off" 
                                    />
                                )}
                                  <Tooltip placement="top" title={"Generar Contraseña"}>
                                  <Button
                                        className="btn-autocomplete"
                                        style={{ width: '40px', fontSize: '14px' }}
                                        icon={'sync'}
                                        onClick = { ()=> {
                                            this.props.form.setFieldsValue({ 
                                                password : this.generatePassword(10)
                                            });
                                        }}
                                    />
                                  </Tooltip>
                                  {/* <Progress percent={100} size="small" /> */}
                                  <h5 className="rb-5">La contraseña debe contener al menos 1 minúscula, 1 mayúscula, 1 número y</h5>
                                  <h5 className="rt-5">1 caracter especial (@#$%^&+=).</h5>
                            </InputGroup>
                        
                            </Form.Item>
                    
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(ContraseniaModal)